<template>
  <div class='EnbProduto02'>
    <enb-img-prod02 :data="data"/>
    <enb-info-prod02 :data="data"/>
  </div>
</template>

<script>
import EnbImgProd02 from './EnbImgProd02'
import EnbInfoProd02 from './EnbInfoProd02'
export default {
  name: 'EnbPorduto02',
  components: { EnbImgProd02, EnbInfoProd02 },
  props: ['data']
}
</script>

<style scoped>
.EnbProduto02 {
  width: 300px;
  height: 400px;
  background-color: #FFFFFF;
  margin: 1%;
  border-radius: 5px;
  overflow: hidden;
  border: thin solid #EEE;
}

.EnbProduto02:hover {
  box-shadow: 1px 1px 5px 0px #333;
}

@media screen and (max-width: 500px) {
  .EnbProduto02 {
    width: 400px;
  }
}
</style>
